import * as React from 'react';
import {createViewConfig, dynamic} from '@sail/engine';

import {LayerContext} from '@sail/global-state';
import {createPortal} from 'react-dom';
import type {ToastLayerProps} from './types';
import {Layer} from '../layers/Layer';
import {css} from '../../css';

export const ToastLayerConfig = createViewConfig({
  name: 'ToastLayer',
  props: {} as ToastLayerProps,
  defaults: {
    placement: 'bottom',
  },
});

/**
 * Toast layer renders children in an isolated "toast" layer.
 *
 * This is used to ensure that toasts are not stacked on top of each other.
 */
export const ToastLayer = ToastLayerConfig.createView(
  ({children, placement, ...props}) => {
    const layerContext = React.useContext(LayerContext);

    /**
     * If already in a toast layer, portal children to the toast layer node.
     */
    if (layerContext?.name === 'toast' && layerContext.node) {
      return createPortal(children, layerContext.node);
    }

    return (
      <Layer noInterop name="toast" {...props}>
        {children}
      </Layer>
    );
  },
  {
    css: {
      left: '50%',
      position: 'fixed',
      transform: 'translateX(-50%)',

      stack: 'y',
      gap: 'small',
      alignItems: 'center',
    },
    uses: [
      dynamic((props) => {
        if (props.placement === 'top') {
          return [css({top: 'small', flexDirection: 'column-reverse'})];
        }

        return [css({bottom: 'small'})];
      }),
    ],
  },
);
